import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  Card,
  Button,
  useTheme,
} from '@mui/material';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import {
  ArrowBack as ArrowBackIcon,
  Dashboard as DashboardIcon,
  Refresh as RefreshIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

// Swagger 문서 목록 (추후 추가될 수 있음)
const API_DOCS = [
  {
    id: 'school',
    label: '학교정보',
    url: 'https://nlpjnsqwqafakrqnnxmq.supabase.co/storage/v1/object/public/swagger/school.yaml', // Swagger JSON 파일 경로
  },
  {
    id: 'admin',
    label: 'Admin API',
    url: '/swagger/admin-api.json', // Swagger JSON 파일 경로
  },
];

const DocsPage: React.FC = () => {
  const [currentTab, setCurrentTab] = useState<string>(API_DOCS[0].id);
  const navigate = useNavigate();
  const theme = useTheme();

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
  };

  const getCurrentDoc = () => {
    return API_DOCS.find(doc => doc.id === currentTab)?.url || '';
  };

  const handleRefresh = () => {
    const swaggerFrame = document.querySelector('.swagger-ui');
    if (swaggerFrame) {
      swaggerFrame.innerHTML = '';
      setCurrentTab(prev => prev);
    }
  };

  return (
    <Box sx={{ 
      minHeight: '100vh',
      bgcolor: 'grey.50',
      pb: 4,
    }}>
      {/* Header */}
      <Box 
        sx={{ 
          bgcolor: 'white',
          borderBottom: 1,
          borderColor: 'grey.200',
          mb: 3,
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ pt: 2, pb: 1 }}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate(-1)}
              >
                돌아가기
              </Button>
              <Button
                startIcon={<DashboardIcon />}
                onClick={() => navigate('/console')}
              >
                콘솔 화면으로 이동
              </Button>
            </Box>
            <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3 }}>
              API 문서
            </Typography>
            <Tabs
              value={currentTab}
              onChange={handleTabChange}
              sx={{
                '& .MuiTab-root': {
                  minWidth: 120,
                  fontWeight: 'bold',
                },
                '& .Mui-selected': {
                  color: 'primary.main',
                },
              }}
            >
              {API_DOCS.map(doc => (
                <Tab
                  key={doc.id}
                  value={doc.id}
                  label={doc.label}
                />
              ))}
            </Tabs>
          </Box>
        </Container>
      </Box>

      {/* Swagger UI */}
      <Container maxWidth="lg">
        <Card 
          elevation={0}
          sx={{ 
            borderRadius: 2,
            '.swagger-ui': {
              'pre, code': {
                fontSize: '13px',
              },
              '.opblock-tag': {
                fontSize: '18px',
                fontWeight: 'bold',
                border: 'none',
                pt: 2,
              },
              '.opblock': {
                borderRadius: '8px',
                border: '1px solid',
                borderColor: 'grey.200',
                boxShadow: 'none',
                mb: 2,
              },
              '.opblock-summary': {
                padding: '8px 16px',
              },
              '.parameter__name, .parameter__type': {
                fontWeight: 'bold',
              },
              '.btn': {
                boxShadow: 'none',
              },
              // 기타 Swagger UI 커스텀 스타일
            },
          }}
        >
          <SwaggerUI
            url={getCurrentDoc()}
            docExpansion="list"
            defaultModelsExpandDepth={-1}
            filter={true}
          />
        </Card>
      </Container>
    </Box>
  );
};

export default DocsPage;
